// extracted by mini-css-extract-plugin
module.exports = {"imgCover":"imgCover___2zWHE"};